import { makeGraphQLRequest } from './utils/requestUtils';

// export async function UserOrgId(id) {
//   // Format Query
//   const query = `query requestUserById(
//         $id: ID
//       ) {
//           user(id: $id) {


//             organizationId 

//           }
//         }`;


//   // Variables
//   const variables = { id };

//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });
//   return response;
// }

export async function getOrgByID(id) {
  // Format Query
  const query = `query organization(
    $id: ID
  ) {
    organization(id: $id) {
      name
   
      cageCode
     
      }
    }`;

  // Variables
  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response.organization;
}

export async function getMessageCount(id) {
  const query = `query msgCount(
    $id: ID
  ) {
    msgCount(id: $id) {

      newMsgCount
      }
    }`;

  // Variables
  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response.msgCount;
}



// WEBPACK FOOTER //
// ./src/graphql.js